<template>
  <v-card class="ma-2">
    <v-card-title flex>
      <!-- <v-btn color="primary" class="elevation-0" @click="onExcelUpload">
        <span>Chọn tệp</span>
        <input
          ref="uploader"
          type="file"
          class="d-none"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          @change="onFileChanged"
        />
      </v-btn> -->

      <v-file-input
        show-size
        label="Chọn File"
        @change="onFileSelected"
        :value="value"
        append-icon="file"
        style="max-width:300px"
      ></v-file-input>

      <v-btn depressed color="primary" @click="save" dark>Lưu lại</v-btn>
    </v-card-title>
  </v-card>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import moment from 'moment'
import XLSX from 'xlsx'
import { ClassNote, Slot, Subject } from '../../plugins/api'
import { get, groupBy, orderBy } from 'lodash'

const schema = {
  'MS học sinh': {
    prop: 'studentCode',
    type: String
  },
  'Tên học sinh': {
    prop: 'studentName',
    type: String
  },
  Lớp: {
    prop: 'studentClass',
    type: String
  },
  'Thông báo khi hiện trên ứng dụng': {
    prop: 'shortContent',
    type: String
  },
  'Nội dung': {
    prop: 'msgContent',
    type: String
  }
}

export default {
  components: {},
  data() {
    return {
      selectedFile: null,
      value: null,
      isLoading: true,
      startOfSchoolYear: '2022-09-04T17:00:00.000Z',
      markComments: [],
      subjectName: '',
      gradeNumber: 0,
      lessonContents: []
    }
  },
  async created() {},
  methods: {
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },

    onFileSelected(file) {
      this.$loading.active = true
      let self = this

      let reader = new FileReader()
      reader.onload = function(e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })
        let sheet1Name = workbook.SheetNames[0]
        let worksheet1 = workbook.Sheets[sheet1Name]
        let sheet1 = XLSX.utils.sheet_to_json(worksheet1)
        self.markComments = sheet1.map(item => {
          return {
            classMark: item.mark,
            classComment: item.comment
          }
        })

        let sheet2Name = workbook.SheetNames[1]
        let worksheet2 = workbook.Sheets[sheet2Name]
        let sheet2 = XLSX.utils.sheet_to_json(worksheet2)
        self.subjectName = sheet2[0].subject.trim()
        self.gradeNumber = sheet2[0].grade
        self.lessonContents = sheet2.map(i => i.content && i.content.trim())
      }
      reader.readAsArrayBuffer(file)

      this.$loading.active = false
    },

    async onFileChanged(e) {
      this.postType = 'notification'
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.excelSMSs = results
      }
      this.$loading.active = false
    },
    async save() {
      this.$loading.active = true

      try {
        const subjects = await Subject.fetch({
          title_contains: this.subjectName,
          'grade.gradeNumber': this.gradeNumber
        })
        const subject = subjects[0]

        const slots = await Slot.fetch({
          subject: subject.id,
          status: 'active',
          _limit: -1
        })

        let startTime = moment(this.startOfSchoolYear).startOf('week')
        const classWithLessonIndexes = []
        while (moment().isAfter(startTime)) {
          const slotByClass = groupBy(slots, 'class.id')
          for (const classId of Object.keys(slotByClass)) {
            const filteredSlots = orderBy(slotByClass[classId], ['day', 'index'], ['asc'])

            for (const item of filteredSlots) {
              const slot = await Slot.fetchOne(item.id)
              const tempSlot = { ...slot }
              delete tempSlot.classNotes

              const markComment = this.markComments[this.getRandomInt(this.markComments.length - 1)]
              let lessonIndex = classWithLessonIndexes[classId] || 1
              const data = {
                lesson: this.lessonContents[lessonIndex - 1],
                date: startTime
                  .clone()
                  .add(slot.day - 1, 'days')
                  .toISOString(),
                index: slot.index,
                day: slot.day,
                indexDay: `${slot.index}-${slot.day}`,
                class: get(slot, 'class.id'),
                subject: get(slot, 'subject.id'),
                teacher: get(slot, 'teacher.id'),
                status: 'on-time',
                data: {
                  lessonIndex: lessonIndex.toString(),
                  ...markComment
                },
                metadata: {
                  slot: tempSlot
                }
              }
              const createdClassNote = await ClassNote.create(data)

              let classNoteIds = []
              if (get(slot, 'classNotes.length')) {
                classNoteIds = [...slot.classNotes.map(cn => cn.id), createdClassNote.id]
              } else {
                classNoteIds = [createdClassNote.id]
              }

              await Slot.update(slot.id, {
                classNotes: classNoteIds
              })

              lessonIndex++
              classWithLessonIndexes[classId] = lessonIndex
            }
          }
          startTime = startTime.add(1, 'week')
        }

        this.$alert.success('Save successfull')
      } catch (error) {
        console.error(error)
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },

    getRandomInt(max) {
      return Math.floor(Math.random() * max)
    }
  }
}
</script>

<style></style>
